import { hasDiscoveryFeatureEntitlement, useDiscoveryFeatureEntitled } from './discoveryEntitlement';

export const RECOMMENDATIONS_FEATURE_KEY = 'recommendations';

export const hasRecommendationsEntitlement = (permissions) =>
  hasDiscoveryFeatureEntitlement(permissions, RECOMMENDATIONS_FEATURE_KEY);

export const useRecommendationsEntitled = () => useDiscoveryFeatureEntitled(RECOMMENDATIONS_FEATURE_KEY);
